/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FailedRansomwareRecoveryDeploymentSpec } from './failedRansomwareRecoveryDeploymentSpec';


export interface FailedRansomwareRecoveryDeploymentByOrgId { 
    /**
     * Attributes of all Ransomware Recovery Deployment failed to assign org key value
     */
    failed_ransomware_recovery_deployment_attributes?: Array<FailedRansomwareRecoveryDeploymentSpec>;
    /**
     * Org id
     */
    org_id?: string;
}

